import { createFileRoute, redirect } from '@tanstack/react-router';
import { selectLoop } from '@/common/utils/loop/selectLoop';

export const Route = createFileRoute('/(app)/org/$org/visualizations/')({
  beforeLoad: async ({ context: { queryClient, organizationId }, params: { org } }) => {
    const loop = await selectLoop(queryClient, organizationId ?? '');
    if (!loop) return;
    throw redirect({
      to: '/org/$org/loop/$loopId/portfolio/table',
      params: { org, loopId: loop.id },
      search: true,
      replace: true,
    });
  },
});
